import React from 'react'

export default function CoPilotNudgeComponent() {
  return (
    <div className='CP_container'>
      <div className='CP_subContainer'>Co-Pilot Nudge</div>
    </div>
  )
}
